/**
 * Work statuses considered "not available", in display/grouping order
 * (break → busy → away). Shared so the header count and the away-members
 * popover agree on what counts as unavailable.
 */
export const UNAVAILABLE_STATUSES = ["break", "busy", "away"] as const;

export const presenceFillClass = (status: string) => {
  if (status === "available") {
    return "fill-green-500 text-green-500";
  }
  if (status === "busy") {
    return "fill-red-500 text-red-500";
  }
  if (status === "away") {
    return "fill-yellow-400 text-yellow-400";
  }
  if (status === "break") {
    return "fill-orange-400 text-orange-400";
  }
  return "fill-gray-400 text-gray-400";
};

export const presenceDotClass = (status: string) => {
  if (status === "available") {
    return "bg-green-500";
  }
  if (status === "busy") {
    return "bg-red-500";
  }
  if (status === "away") {
    return "bg-yellow-400";
  }
  if (status === "break") {
    return "bg-orange-400";
  }
  return "bg-gray-400";
};

export const presenceStatusLabel = (status: string) => {
  switch (status) {
    case "available":
      return "Disponible";
    case "busy":
      return "Ocupado";
    case "away":
      return "Ausente";
    case "break":
      return "En descanso";
    default:
      return "Desconectado";
  }
};
